import React from "react";
import { Modal, ModalBody } from "reactstrap";

function StatusModal({ showModal, setShowModal, handleDelete, actionType }) {
  const handleCloseModal = () => setShowModal(false);

  const message =
    actionType === "deactivate"
      ? "Are you sure to deactivate this account?"
      : "Are you sure to activate this account?";
  const buttonText = actionType === "deactivate" ? "Deactivate" : "Activate";

  return (
    <>
      <Modal isOpen={showModal} toggle={handleCloseModal} centered>
        <ModalBody className="d-flex flex-column justify-content-center align-items-center">
          <h6 className="mt-3 mb-5">{message}</h6>
          <div className="d-flex">
            <button
              className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md ms-3"
              onClick={handleDelete}
            >
              {buttonText}
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default StatusModal;
